/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sandboxes_Searchachievementsplaceholder2Inputs */

const id_sandboxes_searchachievementsplaceholder2 = /** @type {(inputs: Sandboxes_Searchachievementsplaceholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cari pencapaian`)
};

const ms_sandboxes_searchachievementsplaceholder2 = /** @type {(inputs: Sandboxes_Searchachievementsplaceholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cari pencapaian`)
};

const da_sandboxes_searchachievementsplaceholder2 = /** @type {(inputs: Sandboxes_Searchachievementsplaceholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Søg achievements`)
};

const de_sandboxes_searchachievementsplaceholder2 = /** @type {(inputs: Sandboxes_Searchachievementsplaceholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Errungenschaften suchen`)
};

const en_us2_sandboxes_searchachievementsplaceholder2 = /** @type {(inputs: Sandboxes_Searchachievementsplaceholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search achievements`)
};

const es_es2_sandboxes_searchachievementsplaceholder2 = /** @type {(inputs: Sandboxes_Searchachievementsplaceholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscar logros`)
};

const es_mx2_sandboxes_searchachievementsplaceholder2 = /** @type {(inputs: Sandboxes_Searchachievementsplaceholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscar logros`)
};

const fil_sandboxes_searchachievementsplaceholder2 = /** @type {(inputs: Sandboxes_Searchachievementsplaceholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maghanap ng achievement`)
};

const fr_sandboxes_searchachievementsplaceholder2 = /** @type {(inputs: Sandboxes_Searchachievementsplaceholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rechercher des succès`)
};

const it_sandboxes_searchachievementsplaceholder2 = /** @type {(inputs: Sandboxes_Searchachievementsplaceholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerca risultati`)
};

const hu_sandboxes_searchachievementsplaceholder2 = /** @type {(inputs: Sandboxes_Searchachievementsplaceholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teljesítmények keresése`)
};

const nl_sandboxes_searchachievementsplaceholder2 = /** @type {(inputs: Sandboxes_Searchachievementsplaceholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zoek prestaties`)
};

const no_sandboxes_searchachievementsplaceholder2 = /** @type {(inputs: Sandboxes_Searchachievementsplaceholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Søk etter prestasjoner`)
};

const pl_sandboxes_searchachievementsplaceholder2 = /** @type {(inputs: Sandboxes_Searchachievementsplaceholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Szukaj osiągnięć`)
};

const pt_br2_sandboxes_searchachievementsplaceholder2 = /** @type {(inputs: Sandboxes_Searchachievementsplaceholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pesquisar conquistas`)
};

const pt_sandboxes_searchachievementsplaceholder2 = /** @type {(inputs: Sandboxes_Searchachievementsplaceholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pesquisar conquistas`)
};

const ro_sandboxes_searchachievementsplaceholder2 = /** @type {(inputs: Sandboxes_Searchachievementsplaceholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caută realizări`)
};

const fi_sandboxes_searchachievementsplaceholder2 = /** @type {(inputs: Sandboxes_Searchachievementsplaceholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hae saavutuksia`)
};

const sv_sandboxes_searchachievementsplaceholder2 = /** @type {(inputs: Sandboxes_Searchachievementsplaceholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sök prestationer`)
};

const vi_sandboxes_searchachievementsplaceholder2 = /** @type {(inputs: Sandboxes_Searchachievementsplaceholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tìm kiếm thành tích`)
};

const tr_sandboxes_searchachievementsplaceholder2 = /** @type {(inputs: Sandboxes_Searchachievementsplaceholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Başarımları ara`)
};

const cs_sandboxes_searchachievementsplaceholder2 = /** @type {(inputs: Sandboxes_Searchachievementsplaceholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hledat úspěchy`)
};

const bg_sandboxes_searchachievementsplaceholder2 = /** @type {(inputs: Sandboxes_Searchachievementsplaceholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Търсене на постижения`)
};

const ru_sandboxes_searchachievementsplaceholder2 = /** @type {(inputs: Sandboxes_Searchachievementsplaceholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Поиск достижений`)
};

const uk_sandboxes_searchachievementsplaceholder2 = /** @type {(inputs: Sandboxes_Searchachievementsplaceholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пошук досягнень`)
};

const ar_sandboxes_searchachievementsplaceholder2 = /** @type {(inputs: Sandboxes_Searchachievementsplaceholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`البحث عن إنجازات`)
};

const hi_sandboxes_searchachievementsplaceholder2 = /** @type {(inputs: Sandboxes_Searchachievementsplaceholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`उपलब्धियाँ खोजें`)
};

const th_sandboxes_searchachievementsplaceholder2 = /** @type {(inputs: Sandboxes_Searchachievementsplaceholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ค้นหาความสำเร็จ`)
};

const ja_sandboxes_searchachievementsplaceholder2 = /** @type {(inputs: Sandboxes_Searchachievementsplaceholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`実績を検索`)
};

const zh_cn2_sandboxes_searchachievementsplaceholder2 = /** @type {(inputs: Sandboxes_Searchachievementsplaceholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`搜索成就`)
};

const zh_hant1_sandboxes_searchachievementsplaceholder2 = /** @type {(inputs: Sandboxes_Searchachievementsplaceholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`搜尋成就`)
};

const ko_sandboxes_searchachievementsplaceholder2 = /** @type {(inputs: Sandboxes_Searchachievementsplaceholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`도전 과제 검색`)
};

/**
* | output |
* | --- |
* | "Search achievements" |
*
* @param {Sandboxes_Searchachievementsplaceholder2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const sandboxes_searchachievementsplaceholder2 = /** @type {((inputs?: Sandboxes_Searchachievementsplaceholder2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sandboxes_Searchachievementsplaceholder2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_sandboxes_searchachievementsplaceholder2(inputs)
	if (locale === "ms") return ms_sandboxes_searchachievementsplaceholder2(inputs)
	if (locale === "da") return da_sandboxes_searchachievementsplaceholder2(inputs)
	if (locale === "de") return de_sandboxes_searchachievementsplaceholder2(inputs)
	if (locale === "en-US") return en_us2_sandboxes_searchachievementsplaceholder2(inputs)
	if (locale === "es-ES") return es_es2_sandboxes_searchachievementsplaceholder2(inputs)
	if (locale === "es-MX") return es_mx2_sandboxes_searchachievementsplaceholder2(inputs)
	if (locale === "fil") return fil_sandboxes_searchachievementsplaceholder2(inputs)
	if (locale === "fr") return fr_sandboxes_searchachievementsplaceholder2(inputs)
	if (locale === "it") return it_sandboxes_searchachievementsplaceholder2(inputs)
	if (locale === "hu") return hu_sandboxes_searchachievementsplaceholder2(inputs)
	if (locale === "nl") return nl_sandboxes_searchachievementsplaceholder2(inputs)
	if (locale === "no") return no_sandboxes_searchachievementsplaceholder2(inputs)
	if (locale === "pl") return pl_sandboxes_searchachievementsplaceholder2(inputs)
	if (locale === "pt-BR") return pt_br2_sandboxes_searchachievementsplaceholder2(inputs)
	if (locale === "pt") return pt_sandboxes_searchachievementsplaceholder2(inputs)
	if (locale === "ro") return ro_sandboxes_searchachievementsplaceholder2(inputs)
	if (locale === "fi") return fi_sandboxes_searchachievementsplaceholder2(inputs)
	if (locale === "sv") return sv_sandboxes_searchachievementsplaceholder2(inputs)
	if (locale === "vi") return vi_sandboxes_searchachievementsplaceholder2(inputs)
	if (locale === "tr") return tr_sandboxes_searchachievementsplaceholder2(inputs)
	if (locale === "cs") return cs_sandboxes_searchachievementsplaceholder2(inputs)
	if (locale === "bg") return bg_sandboxes_searchachievementsplaceholder2(inputs)
	if (locale === "ru") return ru_sandboxes_searchachievementsplaceholder2(inputs)
	if (locale === "uk") return uk_sandboxes_searchachievementsplaceholder2(inputs)
	if (locale === "ar") return ar_sandboxes_searchachievementsplaceholder2(inputs)
	if (locale === "hi") return hi_sandboxes_searchachievementsplaceholder2(inputs)
	if (locale === "th") return th_sandboxes_searchachievementsplaceholder2(inputs)
	if (locale === "ja") return ja_sandboxes_searchachievementsplaceholder2(inputs)
	if (locale === "zh-CN") return zh_cn2_sandboxes_searchachievementsplaceholder2(inputs)
	if (locale === "zh-Hant") return zh_hant1_sandboxes_searchachievementsplaceholder2(inputs)
	return ko_sandboxes_searchachievementsplaceholder2(inputs)
});
export { sandboxes_searchachievementsplaceholder2 as "sandboxes.searchAchievementsPlaceholder" }